import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

// Components
import { ContentContainer } from '../../../../components/Layout/ContentContainer';
import { Panel } from '../../../../components/Layout/Panel';
import { Screen } from '../../../../components/Layout/Screen';
import Title, { Highlight, Subtext } from '../../../../components/Title';
import GifViewer from '../../../../components/GifViewer';

// Assets
import { brandColors, device } from '../../../../styles/variables';
import room1 from '../../../../assets/images/pages/bridging-the-gap/room3blue.png';
import room2 from '../../../../assets/images/pages/bridging-the-gap/room4green.png';
import room3 from '../../../../assets/images/pages/bridging-the-gap/room2red.png';

const StyledScreen = Screen.extend`
  position: relative;
  background: ${brandColors.blue};
  padding-top: 1px;
  margin-top: -1px;

  .title {
    padding: 20px;
    @media ${device.tablet} {
      padding: 40px;
    }
    @media ${device.laptop} {
      padding: 80px;
    }

    h2 {
      max-width: 100%;
    }

    .subtext {
      max-width: 453px;
      font-size: 16px;
      line-height: 36px;
    }
  }
`;

const StyledContentContainer = ContentContainer.extend`
  overflow: hidden;
`;

const StyledPanel = Panel.extend`
  width: 100%;
  height: 500px;
  @media ${device.tablet} {
    width: 50%;
    height: 50%;
    height: 563px;
  }
  @media ${device.laptop} {
    height: 346px;
  }

  .title {
    padding: 25px;

    .subtext {
      max-width: 100%;
    }
  }
`;

const ImageHolder = styled.div`
  position: absolute;
  right: 50%;
  top: 0;
  bottom: 0;
  width: 50%;
  max-width: 640px;
`;

const ImgPosition1 = styled.div`
  position: absolute;
  width: 70%;
  top: 7%;
  right: -87%;

  @media ${device.tablet} {
    width: 54%;
    top: -10%;
    right: -51%;
  }

  @media ${device.laptop} {
    width: 49%;
    top: -7%;
    right: -51%;
  }
`;

const ImgPosition2 = styled.div`
  position: absolute;
  width: 100%;
  top: 16px;
  left: 20px;

  @media ${device.tablet} {
    width: 93%;
    top: 62px;
    left: 62%;
    transform: translateX(-50%);
  }
  @media ${device.laptop} {
    width: 84%;
    top: 62px;
    left: 0;
    transform: none;
  }
`;

const ImgPosition3 = styled.div`
  position: absolute;
  width: 55%;
  top: 25%;
  right: -46%;
  z-index: 9;

  @media ${device.tablet} {
    width: 49%;
    top: 48%;
    left: 24%;
    right: unset;
  }
  @media ${device.laptop} {
    width: 49%;
    bottom: -9%;
    left: 38%;
    right: unset;
    top: unset;
  }
`;

const HowWeDidItScreen = () => (
  <StyledScreen>
    <ImageHolder>
      <ImgPosition1>
        <GifViewer imgSrc={room3} title="Bridging the gap" gifSrc={room3} />
      </ImgPosition1>

      <ImgPosition2>
        <GifViewer imgSrc={room1} title="Bridging the gap" gifSrc={room1} />
      </ImgPosition2>

      <ImgPosition3>
        <GifViewer imgSrc={room2} title="Bridging the gap" gifSrc={room2} />
      </ImgPosition3>
    </ImageHolder>
    <StyledContentContainer>
      <StyledPanel top="unset" left="unset" right="0" bottom="0">
        <Title primary={false} className="title">
          How we <Highlight>did</Highlight> it
          <Subtext className="subtext">
            We felt that animations would more neatly and effectively convey these patient
            experiences than drama, and proposed an isometric style developed using Cinema 4D. This
            helped to highlight the feeling of isolation experienced by each patient, while allowing
            us to use building blocks to create a picture of their lives as their story was told
            on-screen.
          </Subtext>
        </Title>
      </StyledPanel>
    </StyledContentContainer>
  </StyledScreen>
);

export default connect()(HowWeDidItScreen);



// WEBPACK FOOTER //
// ./src/pages/CaseStudies/BridgingTheGap/screens/HowWeDidIt.jsx